import {lazy} from 'react';

export const ContactPageAsync = lazy(() => import('./ContactPage'));
